<template>
  <div>
    <div class="relative">
      <HeroImage v-if="entry.image[0]" :image="entry.image[0]" class="">
        <div class="flex items-center h-full">
          <div class="lg:px-12 md:block container hidden px-4">
            <div class="box w-1/2">
              <h1 class="fluid-4xl leading-none">
                {{ entry.title }}
              </h1>
              <div v-if="teaserText" class="my-4" v-html="teaserText"></div>
              <CtaArrow
                :to="{ name: `knowledge-index-topic-articles___${$i18n.locale}`, params: { topic: entry.slug } }"
                class="inline-block mt-4 text-white"
                >{{ $t('knowledge.allTopicArticles', { title: entry.title }) }}</CtaArrow
              >
            </div>
          </div>
        </div>
      </HeroImage>
      <div class="md:hidden box block">
        <h1 class="flow-root fluid-4xl leading-none">
          {{ entry.title }}
        </h1>
        <div class="my-4" v-html="entry.teaserText"></div>
        <CtaArrow
          :to="{ name: `knowledge-index-topic-articles___${$i18n.locale}`, params: { topic: entry.slug } }"
          class="inline-block mt-4 text-white"
          >{{ $t('knowledge.allTopicArticles', { title: entry.title }) }}</CtaArrow
        >
      </div>
      <div v-if="categories && categories.length > 1" class="categories-bar 2xl:container lg:block relative hidden">
        <div class="absolute bottom-0 right-0 z-10 flex flex-row items-center h-16 -mb-6 bg-white shadow-lg">
          <div class="px-8 fluid-xs leading-tightest text-gray-600">{{ $t('categories') }}</div>
          <div v-for="category in categories" :key="category.slug">
            <nuxt-link
              :to="{
                name: `knowledge-index-topic-category___${$i18n.locale}`,
                params: { topic: entry.slug, category: category.slug },
              }"
              class="category-link group relative block p-8 pr-10 fluid-xs leading-tightest"
              >{{ category.title }}
              <ArrowIcon class="arrow inline ml-1 -mt-1 h-2.5" />
            </nuxt-link>
          </div>
        </div>
      </div>
    </div>
    <div>
      <ContentBlocks v-if="entry" :entry="entry" />
    </div>
  </div>
</template>

<script>
import HeroImage from '~/components/common/HeroImage';
import CtaArrow from '~/components/common/CtaArrow';
import ContentBlocks from '@/components/common/ContentBlocks';
import ArrowIcon from '~/components/icons/ArrowIcon';

export default defineNuxtComponent({
  name: 'TopicPage',
  components: {
    HeroImage,
    CtaArrow,
    ContentBlocks,
    ArrowIcon,
  },
  props: {
    entry: {
      type: Object,
      default: null,
    },
    categories: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    teaserText() {
      return this.entry?.teaserText;
    },
  },
});
</script>

<style scoped>
@reference "~/assets/css/main.css";
.category-link .arrow {
  @apply fill-[#ffffff];
}
.category-link:hover .arrow {
  @apply fill-[#000000];
}
</style>
